import { LeftOutlined } from "@ant-design/icons"
import { Drawer, Flex, Layout } from "antd"
import React, { useCallback } from "react"
import { useNavigate } from "react-router"

import { useAppDispatch } from "../../hooks/use-app-dispatch.ts"
import { useAppSelector } from "../../hooks/use-app-selector.ts"
import { toggleMobileMenu, toggleSideBar } from "../../redux/nav/nav.slice.ts"
import { cn } from "../../utils/cn.ts"
import { SidebarBody } from "./SidebarBody.tsx"
import { type SidebarItem } from "./sidebar-config.tsx"
import "./styles.less"

const backgroundColor = "#FFFFFF"

export const SidebarController = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const isMobile = useAppSelector((state) => state?.nav.isMobile)
  const isMobileMenuOpen = useAppSelector(
    (state) => state?.nav.isMobileMenuOpen
  )
  const isSidebarOpen = useAppSelector((state) => state?.nav.isSidebarOpen)

  const handleToggleMobileMenu = useCallback(() => {
    dispatch(toggleMobileMenu())
  }, [dispatch])

  const handleMenuClick = useCallback(
    (item: Pick<SidebarItem, "key">) => {
      const path = item?.key
      navigate(`/${path}`)
    },
    [navigate]
  )

  const handleMobileMenuClick = useCallback(
    (item: Pick<SidebarItem, "key">) => {
      handleMenuClick(item)
      handleToggleMobileMenu()
    },
    [handleMenuClick, handleToggleMobileMenu]
  )

  if (isMobile) {
    return (
      <Drawer
        title={null}
        placement="left"
        onClose={handleToggleMobileMenu}
        open={isMobileMenuOpen}
        width={280}
        className="md:hidden"
        styles={{
          body: { padding: 0, backgroundColor },
          header: { display: "none" }
        }}
      >
        <div className={"md:px-4 size-full"}>
          <SidebarBody onItemSelect={handleMobileMenuClick} />
        </div>
      </Drawer>
    )
  }

  return (
    <Layout.Sider
      collapsedWidth={50}
      collapsed={!isSidebarOpen}
      collapsible
      trigger={null}
      className="hidden border group border-border z-10 sticky top-[var(--header-height)] h-[calc(100vh-var(--header-height))] border-t-0 md:block"
      data-state={isSidebarOpen ? "open" : "closed"}
      width={205}
      style={{ backgroundColor }}
    >
      <SidebarBody
        onItemSelect={handleMenuClick}
        // showDefaultOpenKeys={isSidebarOpen}
      />

      <Flex
        align={"center"}
        justify={"center"}
        onClick={() => dispatch(toggleSideBar())}
        className="absolute -right-2.5 top-1/2 -translate-y-1/2 z-20 bg-white w-4 h-16 border border-border hover:bg-gray-100 cursor-pointer rounded-sm transition-colors shadow-sm"
      >
        <LeftOutlined
          className={cn(
            "text-xs transition-all duration-300",
            !isSidebarOpen && "rotate-180"
          )}
        />
      </Flex>
    </Layout.Sider>
  )
}
